// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"arrow-triangle-up"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M17.5 11L12 3.75L6.5 11H10V21H14V11H17.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M17.5 11L12 3.75L6.5 11H10V21H14V11H17.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-arrow-triangle-up')
export default class ArrowTriangleUpIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'arrow-triangle-up',
    }
  }
}
